module.exports = __webpack_public_path__ + "static/media/ArcTocuh-Logo.d3bac1fd.svg";